import { render } from "./Trophies.vue?vue&type=template&id=a89313a0&scoped=true"
import script from "./Trophies.vue?vue&type=script&lang=js"
export * from "./Trophies.vue?vue&type=script&lang=js"

import "./Trophies.vue?vue&type=style&index=0&id=a89313a0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\dinho\\Documents\\GitHub\\Grajaú-E-SPORTS\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89313a0"]])

export default __exports__